<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th style="padding-top: 0;padding-bottom: 0;">
                        <span class="recommend">おすすめ！</span><br>給湯器専門業者
                        <br>
                        <img src="../../assets/cocmparision/1.png" alt="">
                    </th>
                    <th class="gas" style="padding-bottom: 0;">
                        ガス会社
                        <br>
                        電力会社
                        <br>
                        <img src="../../assets/cocmparision/2.png" alt="">
                    </th>
                    <th class="kaden" style="padding-bottom: 0;">
                        家電量販店
                        <br>
                        ホームセンター
                        <br>
                        <img src="../../assets/cocmparision/3.png" alt="">
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td></td>
                    <td class="td-item-title">本体の価格</td>
                    <td></td>
                </tr>
                <tr>
                    <td>
                        <div class="double-circle"></div>
                        <br>
                        <span class="highlight">最大92%OFF</span>
                    </td>
                    <td>
                        <div class="cross"></div>
                        <br>
                        <span>相場より高め</span>
                    </td>
                    <td>
                        <div class="triangle"></div>
                        <br>
                        <span>割引率低め</span>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td class="td-item-title">費用総額の相場</td>
                    <td></td>
                </tr>
                <tr>
                    <td>
                        <div class="double-circle"></div>
                        <br>
                        <span class="highlight">8〜18万円程度</span>
                    </td>
                    <td>
                        <div class="triangle"></div>
                        <br>
                        <span>20〜30万円程度</span>
                    </td>
                    <td>
                        <div class="triangle"></div>
                        <br>
                        <span>15〜30万円程度</span>
                    </td>
                </tr>
                <!-- <tr>
                    <td></td>
                    <td class="td-item-title">専門知識</td>
                    <td></td>
                </tr>
                <tr>
                    <td>
                        <div class="double-circle"></div>
                        <br>
                        <span class="highlight">知識が豊富</span>
                    </td>
                    <td>
                        <div class="circle"></div>
                        <br>
                        <span>知識あり</span>
                    </td>
                    <td>
                        <div class="triangle"></div>
                        <br>
                        <span>少ない</span>
                    </td>
                </tr> -->
                <tr>
                    <td></td>
                    <td class="td-item-title">対応スピード</td>
                    <td></td>
                </tr>
                <tr>
                    <td>
                        <div class="double-circle"></div>
                        <span class="highlight">当日対応可能</span>
                    </td>
                    <td>
                        <div class="triangle"></div>
                        <br>
                        <span>数日~数週間</span>
                    </td>
                    <td>
                        <div class="triangle"></div>
                        <br>
                        <span>数日~数週間</span>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td class="td-item-title">保証の有無</td>
                    <td></td>
                </tr>
                <tr>
                    <td>
                        <div class="double-circle"></div>
                        <span class="highlight">無料10年保証</span>
                    </td>
                    <td>
                        <div class="triangle"></div>
                        <br>
                        <span>有料</span>
                    </td>
                    <td>
                        <div class="triangle"></div>
                        <br>
                        <span>有料</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
</script>

<style scoped>
.table {
    width: 100%;
    table-layout: fixed;
    text-align: center;
    border-collapse: collapse;
    border-spacing: 0;
    color: #353535;
}

.table thead {
    background: #999;
    color: #fff;
}

.table th,
.table td {
    border: 1px solid #ccc;
    padding: 10px;
    width: 33.333%;
}

.table tr:nth-child(2n) td {
    background-color: #fafafa;
}

.table th:nth-child(1),
.table td:nth-child(1) {
    border-left: 5px solid #3095e5;
    border-right: 5px solid #3095e5;
}

.table tr:first-child th:first-child {
    position: relative;
    border-top: 15px solid #3095e5;
    background-color: #3095e5;
}

.table tr:last-child td:first-child {
    border-bottom: 5px solid #3095e5;
}

tbody tr .td-item-title {
    padding: 5px;
    border-right: solid #f0f0fb;
    font-weight: 700;
    font-size: 0.8rem;
}

tr {
    font-size: 0.8rem;
}

td br {
    display: none;
}

td span {
    margin-top: 5px;
    display: block;
}

th {
    font-size: 0.8rem;
    margin-bottom: 5px;
}

table img {
    width: 90%;
    margin-top: 10px;
}

.kaden img {
    width: 80%;
}

.gas img {
    width: 80%;
}

.recommend {
    display: inline-block;
    background: #ff9800;  
    color: #fff;
    font-weight: bold;
    padding: 3px 8px;
    border-radius: 10px;
    font-size: 0.8rem;
}

.highlight {
    display: inline-block;
    background: #ffeb3b;
    color: #d32f2f;
    font-weight: bold;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 0.8rem;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    td, .highlight,
    tr, .recommend {
        font-size: 0.9rem;
    }
    .td-item-title {
        font-size: 1rem;
    }

    th {
        font-size: 0.8rem;
    }

    .highlight {
        font-weight: 600;
    }

    .recommend {
        font-size: 0.7rem;
    }
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 480px) {
    td, .highlight,
    tr, .recommend {
        font-size: 0.8rem;
    }
    .app-container {
        padding: 10px;
        margin: 0;
    }

    td {
        font-size: 0.8rem;
    }

    th {
        font-size: 0.8rem;
    }

    .td-item-title {
        font-size: 0.95rem;
    }

    .highlight {
        padding: 3px;
    }
}
</style>
